var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiIconUtility16Water({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.847c1.171 1.627 4.5 6.431 4.5 8.486 0 1.147-.501 2.184-1.306 2.935A4.67 4.67 0 0 1 8 14.5a4.67 4.67 0 0 1-3.194-1.232C4 12.517 3.5 11.48 3.5 10.333 3.5 8.27 6.828 3.472 8 1.847z",
    stroke: "#0283FB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiIconUtility16Water);
export default __webpack_public_path__ + "static/media/ui-icon-utility-16-water.ce164219.svg";
export { ForwardRef as ReactComponent };